<template>
  <div>
    <v-container fluid>
      <v-card class="card2" style="margin-top: 1rem">
        <v-card-text>
          <v-row >
            <v-col cols="12" md="6">
              <h1 style="font-weight: 600; font-size: 28px;" class="mr-4">Shortcut Menu</h1>
            </v-col>
            <v-col cols="6" class="d-flex flex-wrap justify-end gap-2">
                  <div class="custom-search-input-wrapper">
                    <div class="custom-search-input-container">
                      <v-icon class="custom-search-input-icon">mdi-magnify</v-icon>
                      <input id="shortcut-commands-field-search-modelshortcut-commands" type="text" placeholder="Shortcut Group Name"
                        class="custom-search-input" v-model="searchName" @keydown.enter="Search" />
                      <v-icon class="clear-icon" :style="searchName ? '' : 'color: transparent !important;'"
                        @click="searchName = ''">
                        mdi-close-circle
                      </v-icon>
                    </div>
                  </div>
              <v-btn
                id="button-add-popupadd-modelshortcut-commands"
                class="control-btn create-btn customadd"
                variant="flat"
                size="large"
                prepend-icon="mdi-plus"
                rounded="xl"
                @click="Add()"
              >
              {{ $t("add") }}
              <v-tooltip activator="parent" location="top">Add Shortcut Menu</v-tooltip>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
        <v-data-table-server
          :items-per-page="options.itemsPerPage"
          :items-length="searchTotalTable"
          v-model:options="options"
          :items="menus"
          :headers="headers"
          :loading="loadingTable"
          class="pa-5"
        >
          <template v-slot:item="{ item,index }">
            <tr>
              <td style="text-align: center">{{ (options.page - 1) * options.itemsPerPage + index + 1 }}</td>
              <td>{{ item.nameDisplay }}</td>
              <td style="text-align: left">
                {{ item.listCommand }}
              </td>
              <td style="text-align: center">
                <div class="action-group" style="justify-content: center;">
                  <!-- Edit -->
                  <v-btn
                    id="button-edit-popupedit-modelshortcut-commands"
                    variant="text"
                    density="comfortable"
                    @click="Edit(item)"
                    class="action-btn edit-btn"
                    icon
                  >
                    <v-img :src="images.editBtn" width="23" height="23"></v-img>
                    <v-tooltip activator="parent" location="top">
                      Edit
                    </v-tooltip>
                  </v-btn>                
                  <!-- Delete -->
                  <v-btn
                    id="button-delete-popupdelete-modelshortcut-commands"
                    variant="text"
                    density="comfortable"
                    @click="DeleteGroup(item.shortcutMenuGroupID)"
                    class="action-btn delete-btn"
                    icon
                  >
                    <v-img :src="images.deleteBtn" width="23" height="23"></v-img>
                    <v-tooltip activator="parent" location="top">
                      Delete
                    </v-tooltip>
                  </v-btn>
                </div>
              </td>
            </tr>
          </template>
          <!-- 👇 Custom footer area -->
          <template v-slot:bottom>
            <div
              class="d-flex justify-space-between align-center px-4 py-2"
              style="width: 100%"
            >
              <div>Total results {{ searchTotalTable }}</div>

              <v-data-table-footer
                v-model:items-per-page="itemsPerPage"
                :page="options.page"
                :length="Math.ceil(searchTotalTable / itemsPerPage)"
              />
            </div>
          </template>
        </v-data-table-server>
      </v-card>
    </v-container>
    <!-- Loading Please Wait... -->
    <v-overlay :model-value="loading" class="align-center justify-center" persistent>
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular
            indeterminate
            size="64"
            color="primary"
            class="mb-4"
          ></v-progress-circular>
          <h3 class="loading-title">Loading...</h3>
          <p class="loading-subtitle">Please wait</p>
        </v-card-text>
      </v-card>
    </v-overlay>
    <!-- Edit -->
    <v-dialog v-model="Editdialog" max-width="900px" persistent scrollable class="modern-dialog">
      <v-card class="dialog-card">
        <!-- Header -->
        <div class="dialog-header dialog-header-add">
          <div class="header-main">
            <div class="header-text-content">
              <div class="title-with-chip">
                <h2 class="dialog-title">Edit Shortcut Menu</h2>
                <v-chip
                  v-if="Shortcutmenu.listShortcuts && Shortcutmenu.listShortcuts.length > 0"
                  size="small"
                  variant="tonal"
                  color="primary"
                  class="summary-chip"
                >
                  {{ Shortcutmenu.listShortcuts.length }} command{{ Shortcutmenu.listShortcuts.length === 1 ? '' : 's' }} configured
                </v-chip>
              </div>
              <p class="dialog-subtitle">Modify shortcut menu configuration</p>
            </div>
          </div>
          <div class="header-actions">
            <v-btn
                icon
                variant="text"
                @click="Editdialog = false"
                class="close-button"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
          </div>
        </div>
        <!-- Content -->
        <v-card-text class="dialog-content">
          <div class="form-container">
            <!-- Basic Information Section -->
            <div class="form-section">
              <div class="section-header">
                <h3 class="section-title d-flex"> <v-img :src="images.basicInfo" width="20" height="20" class="mr-5"></v-img> Basic Information</h3>
              </div>
              
              <v-row>
                <v-col cols="12">
                  <div class="input-wrapper">
                    <div class="input-label">
                      <span>Shortcut Commands Group Name</span>
                      <span class="required-asterisk">*</span>
                      <v-tooltip location="top" max-width="300px">
                        <template v-slot:activator="{ props }">
                          <v-icon
                            size="small"
                            v-bind="props"
                            color="grey-darken-1"
                            class="help-icon"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <span>The unique name or label assigned to this specific collection of related quick-access system commands and predefined actions.</span>
                      </v-tooltip>
                    </div>
                    
                    <v-text-field
                      id="shortcut-commandsgroupname-field-popupedit-modelshortcut-commands"
                      v-model="Shortcutmenu.groupName"
                      :rules="[rules.required]"
                      variant="outlined"
                      density="comfortable"
                      placeholder="Enter group name..."
                      hide-details="auto"
                      class="modern-input"
                    />
                  </div>
                </v-col>
              </v-row>
            </div>
          </div>
          <div class="form-container mt-5">
            
            <!-- Shortcut Commands Section -->
            <div class="form-section">
              <div class="section-header">  
                <h3 class="section-title d-flex"> <v-img :src="images.chatInfo" width="20" height="20" class="mr-2"></v-img>{{ $t("ShortcutCommands") }}</h3>
                <v-tooltip location="top" max-width="300px">
                        <template v-slot:activator="{ props }">
                          <v-icon
                            size="small"
                            v-bind="props"
                            class="help-icon"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <span>Configure shortcut commands with labels, messages, and custom icons.</span>
                      </v-tooltip>
                <v-chip
                  v-if="Shortcutmenu.listShortcuts && Shortcutmenu.listShortcuts.length > 0"
                  size="small"
                  variant="tonal"
                  color="info"
                  class="summary-chip"
                >
                  {{ Shortcutmenu.listShortcuts.length }} {{ Shortcutmenu.listShortcuts.length === 1 ? 'command' : 'commands' }}
                </v-chip>
              </div>
              <!-- Shortcut Commands Table -->
              <div class="table-container">
                <v-table class="modern-table" density="compact">
                  <thead>
                    <tr>
                      <th class="table-header">#</th>
                      <th class="table-header label-col">{{ $t("Label") }}
                        <v-tooltip location="top" max-width="300px">
                              <template v-slot:activator="{ props }">
                                <v-icon
                                  size="small"
                                  v-bind="props"
                                  color="grey-darken-1"
                                >
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>Shortcut commands name</span>
                            </v-tooltip>
                      </th>
                      <th class="table-header label-col">{{ $t("Message") }}
                        <v-tooltip location="top" max-width="300px">
                              <template v-slot:activator="{ props }">
                                <v-icon
                                  size="small"
                                  v-bind="props"
                                  color="grey-darken-1"
                                >
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>Shortcut Commands data that will be sent</span>
                            </v-tooltip>
                      </th>
                      <th class="table-header" style="text-align: center;">{{ $t("UploadImage") }}</th>
                      <th class="table-header" style="text-align: center;">{{ $t("UploadImageEx") }}</th>
                      <th class="table-header actions-col" style="text-align: center;">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in Shortcutmenu.listShortcuts"
                      :key="index"
                      class="table-row"
                    >
                      <td class="table-cell number-cell">{{ index + 1 }}</td>
                      
                      <td class="table-cell">
                        <v-text-field
                          :id="'label-field-popupedit-modelshortcut-commands-' + index"
                          v-model="item.nameDisplay"
                          variant="outlined"
                          density="compact"
                          hide-details
                          class="table-input"
                          placeholder="Quick reply name"
                        >
                        </v-text-field>
                      </td>
                      
                      <td class="table-cell">
                        <v-text-field
                          :id="'message-field-popupedit-modelshortcut-commands-' + index"
                          v-model="item.command"
                          variant="outlined"
                          density="compact"
                          hide-details
                          class="table-input"
                          placeholder="Quick reply data"
                        >
                        </v-text-field>
                      </td>
                      
                      <td class="table-cell upload-cell">
                        <v-btn
                          :id="'button-upload-popupadd-modelshortcut-commands-' + index"
                          color="#C32E0E"
                          variant="outlined"
                          size="small"
                          class="upload-btn"
                          @click="Click_FileButtonShortcutMenu(index)"
                        >
                          <v-img :src="images.iconcolImg" class="mr-2" width="16" height="16" alt="Upload"></v-img>
                          {{ $t("UploadImage") }}
                          <v-tooltip v-if="item.imageURL && item.imageURL !== ''" activator="parent" location="top">
                              Change Icon
                          </v-tooltip>
                          <v-tooltip v-else activator="parent" location="top">
                              Upload Icon
                            </v-tooltip>
                        </v-btn>
                      </td>
                      <td class="table-cell preview-cell">
                        <div class="image-preview">
                          <div
                            class="preview-avatar"
                          >
                            <img
                              v-if="item.imageURL && item.imageURL !== ''"
                              :src="item.imageURL"
                              alt="Preview"
                            />
                            <v-img v-else :src="images.iconpreviewImg"></v-img>
                        </div>
                        </div>
                      </td>
                      <td class="table-cell actions-cell">
                        <div class="action-buttons">
                          <v-btn
                            :id="'button-deleterowmodel-popupadd-modelshortcut-commands-' + index"
                            :disabled="index == 0 && Shortcutmenu.listShortcuts.length == 1"
                            icon
                            size="small"
                            color="error"
                            variant="flat"
                            class="actionbtns removebtns mr-4"
                            @click="Minus_ShortcutMenu(index)"
                          >
                            <v-icon size="30">mdi-minus</v-icon>
                            <v-tooltip activator="parent" location="top">
                              Remove Command
                            </v-tooltip>
                          </v-btn>
                          
                          <v-btn
                            :id="'button-addrowmodel-popupadd-modelshortcut-commands-' + index"
                            icon
                            size="small"
                            color="success"
                            variant="flat"
                            class="actionbtns addbtn"
                            @click="Plus_ShortcutMenu(index)"
                          >
                            <v-icon size="30">mdi-plus</v-icon>
                            <v-tooltip activator="parent" location="top">
                              Add Command
                            </v-tooltip>
                          </v-btn>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </v-table>
              </div>
            </div>
          </div>
          <!-- Hidden file input -->
          <input
            id="inputfileShortcutMenu"
            ref="bindFileNameShortcutMenu"
            type="file"
            @change="ShortcutMenuIcon"
            style="display: none"
            accept="image/png,image/jpeg"
          />
        </v-card-text>

        <!-- Actions -->
        <v-card-actions class="dialog-actions"> 
            <div class="actions-right">
              <v-btn
                variant="outlined"
                @click="Editdialog = false"
                class="dialog-action-btn cancel-btn"
              >
                {{ $t("cancel") }}
              </v-btn>

              <v-btn
                id="button-save-popupadd-modelshortcut-commands"
                variant="elevated"
                @click="Save"
                class="dialog-action-btn save-btn-edit"
                :loading="dialog"
              >
              <v-img :src="images.saveImg" width="20" height="20" class="mr-2"/>
                {{ $t("save") }}
              </v-btn>
            </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Add -->
    <v-dialog v-model="Adddialog" max-width="900px" persistent scrollable class="modern-dialog">
      <v-card class="dialog-card">
        <!-- Header -->
        <div class="dialog-header dialog-header-add">
          <div class="header-main">
            <div class="header-text-content">
              <div class="title-with-chip">
                <h2 class="dialog-title">Add Shortcut Menu</h2>
                <v-chip
                  v-if="Shortcutmenu.listShortcuts && Shortcutmenu.listShortcuts.length > 0"
                  size="small"
                  variant="tonal"
                  color="primary"
                  class="summary-chip"
                >
                  {{ Shortcutmenu.listShortcuts.length }} command{{ Shortcutmenu.listShortcuts.length === 1 ? '' : 's' }} configured
                </v-chip>
              </div>
              <p class="dialog-subtitle">Create a new shortcut menu</p>
            </div>
          </div>
          <div class="header-actions">
            <v-btn
                icon
                variant="text"
                @click="Adddialog = false"
                class="close-button"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
          </div>
        </div>

        <!-- Content -->
        <v-card-text class="dialog-content">
          <div class="form-container">
            <!-- Basic Information Section -->
            <div class="form-section">
              <div class="section-header">
                <h3 class="section-title d-flex"> <v-img :src="images.basicInfo" width="20" height="20" class="mr-5"></v-img> Basic Information</h3>
              </div>
              
              <v-row>
                <v-col cols="12">
                  <div class="input-wrapper">
                    <div class="input-label">
                      <span>Shortcut Commands Group Name</span>
                      <span class="required-asterisk">*</span>
                      <v-tooltip location="top" max-width="300px">
                        <template v-slot:activator="{ props }">
                          <v-icon
                            size="small"
                            v-bind="props"
                            class="help-icon"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <span>The unique name or label assigned to this specific collection of related quick-access system commands and predefined actions.</span>
                      </v-tooltip>
                    </div>
                    
                    <v-text-field
                      id="shortcut-commands-groupname-field-popupadd-modelshortcut-commands"
                      v-model="Shortcutmenu.groupName"
                      :rules="[rules.required]"
                      variant="outlined"
                      density="comfortable"
                      placeholder="Enter Group Name..."
                      hide-details="auto"
                      class="modern-input"
                    />
                  </div>
                </v-col>
              </v-row>
            </div>
          </div>

          <div class="form-container mt-5">
            <!-- Shortcut Commands Section -->
            <div class="form-section">
              <div class="section-header">  
                <h3 class="section-title d-flex"> <v-img :src="images.chatInfo" width="20" height="20" class="mr-2"></v-img>{{ $t("ShortcutCommands") }}</h3>
                <v-tooltip location="top" max-width="300px">
                        <template v-slot:activator="{ props }">
                          <v-icon
                            size="small"
                            v-bind="props"
                            class="help-icon"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <span>Configure shortcut commands with labels, messages, and custom icons.</span>
                      </v-tooltip>
                <v-chip
                  v-if="Shortcutmenu.listShortcuts && Shortcutmenu.listShortcuts.length > 0"
                  size="small"
                  variant="tonal"
                  color="info"
                  class="summary-chip"
                >
                  {{ Shortcutmenu.listShortcuts.length }} {{ Shortcutmenu.listShortcuts.length === 1 ? 'command' : 'commands' }}
                </v-chip>
              </div>

              <!-- Shortcut Commands Table -->
              <div class="table-container">
                <v-table class="modern-table" density="compact">
                  <thead>
                    <tr>
                      <th class="table-header">#</th>
                      <th class="table-header label-col">{{ $t("Label") }}
                        <v-tooltip location="top" max-width="300px">
                              <template v-slot:activator="{ props }">
                                <v-icon
                                  size="small"
                                  v-bind="props"
                                  color="grey-darken-1"
                                >
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>Shortcut commands name</span>
                            </v-tooltip>
                      </th>
                      <th class="table-header label-col">{{ $t("Message") }}
                        <v-tooltip location="top" max-width="300px">
                              <template v-slot:activator="{ props }">
                                <v-icon
                                  size="small"
                                  v-bind="props"
                                  color="grey-darken-1"
                                >
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>Shortcut Commands data that will be sent</span>
                            </v-tooltip>
                      </th>
                      <th class="table-header" style="text-align: center;">{{ $t("UploadImage") }}</th>
                      <th class="table-header" style="text-align: center;">{{ $t("UploadImageEx") }}</th>
                      <th class="table-header actions-col" style="text-align: center;">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in Shortcutmenu.listShortcuts"
                      :key="index"
                      class="table-row"
                    >
                      <td class="table-cell number-cell">{{ index + 1 }}</td>
                      
                      <td class="table-cell">
                        <v-text-field
                          :id="'label-field-popupadd-modelshortcut-commands-' + index"
                          v-model="item.nameDisplay"
                          variant="outlined"
                          density="compact"
                          hide-details
                          class="table-input"
                          placeholder="Enter Label"
                        >
                        </v-text-field>
                      </td>
                      
                      <td class="table-cell">
                        <v-text-field
                          :id="'message-field-popupadd-modelshortcut-commands-' + index"
                          v-model="item.command"
                          variant="outlined"
                          density="compact"
                          hide-details
                          class="table-input"
                          placeholder="Enter Message"
                        >
                        </v-text-field>
                      </td>
                      
                      <td class="table-cell upload-cell">
                        <v-btn
                          :id="'button-upload-popupadd-modelshortcut-commands-' + index"
                          color="#C32E0E"
                          variant="outlined"
                          size="small"
                          class="upload-btn"
                          @click="Click_FileButtonShortcutMenu(index)"
                        >
                          <v-img :src="images.iconcolImg" class="mr-2" width="16" height="16" alt="Upload"></v-img>
                          {{ $t("UploadImage") }}
                          <v-tooltip v-if="item.imageURL && item.imageURL !== ''" activator="parent" location="top">
                              Change Icon
                          </v-tooltip>
                          <v-tooltip v-else activator="parent" location="top">
                              Upload Icon
                            </v-tooltip>
                        </v-btn>
                      </td>
                      
                      <td class="table-cell preview-cell">
                        <div class="image-preview">
                          <div
                            class="preview-avatar"
                          >
                            <img
                              v-if="item.imageURL && item.imageURL !== ''"
                              :src="item.imageURL"
                              alt="Preview"
                            />
                            <v-img v-else :src="images.iconpreviewImg"></v-img>
                        </div>
                        </div>
                      </td>
                      
                      <td class="table-cell actions-cell">
                        <div class="action-buttons">
                          <v-btn
                            :id="'button-deleterowmodel-popupadd-modelshortcut-commands-' + index"
                            :disabled="index == 0 && Shortcutmenu.listShortcuts.length == 1"
                            icon
                            size="small"
                            color="error"
                            variant="flat"
                            class="actionbtns removebtns mr-4"
                            @click="Minus_ShortcutMenu(index)"
                          >
                            <v-icon size="30">mdi-minus</v-icon>
                            <v-tooltip activator="parent" location="top">
                              Remove Command
                            </v-tooltip>
                          </v-btn>
                          
                          <v-btn
                            :id="'button-addrowmodel-popupadd-modelshortcut-commands-' + index"
                            icon
                            size="small"
                            color="success"
                            variant="flat"
                            class="actionbtns addbtn"
                            @click="Plus_ShortcutMenu(index)"
                          >
                            <v-icon size="30">mdi-plus</v-icon>
                            <v-tooltip activator="parent" location="top">
                              Add Command
                            </v-tooltip>
                          </v-btn>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </v-table>
              </div>
            </div>
          </div>

          <!-- Hidden file input -->
          <input
            id="inputfileShortcutMenu"
            ref="bindFileNameShortcutMenu"
            type="file"
            @change="ShortcutMenuIcon"
            style="display: none"
            accept="image/png,image/jpeg"
          />
        </v-card-text>

        <!-- Actions -->
        <v-card-actions class="dialog-actions"> 
            <div class="actions-right">
              <v-btn
                variant="outlined"
                @click="Adddialog = false"
                class="dialog-action-btn cancel-btn"
              >
                {{ $t("cancel") }}
              </v-btn>

              <v-btn
                id="button-save-popupadd-modelshortcut-commands"
                variant="elevated"
                @click="Save"
                class="dialog-action-btn save-btn-add"
                :loading="dialog"
              >
              <v-img :src="images.saveImg" width="20" height="20" class="mr-2"/>
                {{ $t("save") }}
              </v-btn>
            </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="Detaildialog" max-width="400px">
      <v-card>
        <v-card-title
          class="text-h5 grey lighten-2"
          style="margin-bottom: 1rem; position: sticky; top: 0px; z-index: 1"
        >
          {{ $t("modelName") }}
        </v-card-title>
        <v-card-text v-for="item in TempModel" :key="item.id">
          <v-row>
            <v-col cols="10" sm="10" md="10">
              <span style="margin-right: 1rem">{{ item.name }}</span>
            </v-col>
            <v-col cols="2" sm="2" md="2">
              <v-btn
                id="botton-view-popupview-modelshortcut-commands"
                icon
                v-bind="attrs"
                @click="View(item)"
              >
                <v-icon att>mdi-eye</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-spacer></v-spacer>
          <v-divider></v-divider>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- Custom Delete Dialog -->
    <v-dialog v-model="dialog_delete" max-width="600px" persistent>
      <v-card class="delete-dialog-card">
        <div class="delete-dialog-header">
          <span class="delete-dialog-title">Delete Confirmation</span>
          <v-btn
            icon
            variant="text"
            size="small"
            class="delete-close-icon"
            @click="cancelDelete"
          >
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </div>
        
        <!-- Content -->
        <v-card-text class="delete-dialog-content">
          <span v-if="deleteItem">
            Do you want to confirm deletion of this shortcut menu?
          </span>
        </v-card-text>
        
        <!-- Actions -->
        <v-card-actions class="delete-dialog-actions">
          <v-btn
            class="delete-cancel-btn"
            @click="cancelDelete"
          >
            Cancel
          </v-btn>
          <v-btn
            class="delete-confirm-btn"
            @click="confirmDelete"
          >
            <v-img :src="images.deleteIcon" width="20" height="20" class="mr-2"/>
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import checkPermissionTwo from "@/api/function.js";
import editImg from "@/assets/edit1.png";
import deleteImg from "@/assets/delete1.png";
import editBtn from '@/assets/images/editbutton.png';
import deleteBtn from '@/assets/images/trashbutton.png';
import basicInfo from "@/assets/images/basicinfo.png";
import chatInfo from "@/assets/images/chat.png";
import saveImg from '@/assets/images/savecard.png';
import iconcolImg from '@/assets/images/iconcol.png';
import iconpreviewImg from '@/assets/images/iconpreview.png';
import deleteIcon from "@/assets/images/trash-solid.svg";
export default {
  name: "ModelShortcutMenu",
  mixins: [checkPermissionTwo],
  inject : ['FontColorTitle','SubNavbarBackGround'],
  data: () => ({
    indexImportFile: null,

    importData: null,

    checkbox1: false,
    Editdialog: false,
    Adddialog: false,
    Detaildialog: false,
    dialog: false,
    valid: true,
    tempID: 0,
    MenuID1: null,
    MenuID2: null,
    MenuID3: null,
    menuID: null,
    subMenuID: null,
    today: null,
    maxLengthChar: 0,
    searchTotalTable: 0,
    totalTable: 0,
    itemsPerPage: 10,
    loading: false,
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    rules: {
      required: (value) => !!value || "Required.",
    },
    DDGPTModel: [],
    headers_version_history: [],
    dialog_delete: false,
    deleteItem: null,
    searchName: "",
    isSearch: false,
    isFirst: true,
    menus: [],
    QuickGroup: [],
    quickReplyType: ["postback", "message"],
    images: {
      edit: editImg,
      delete: deleteImg,
      deleteBtn: deleteBtn,
      editBtn: editBtn,
      basicInfo: basicInfo,
      chatInfo: chatInfo,
      saveImg: saveImg,
      iconcolImg: iconcolImg,
      iconpreviewImg: iconpreviewImg,
      deleteIcon: deleteIcon,
    },
    Shortcutmenu: {
      shortcutMenuGroupID: null,
      groupName: null,
      listShortcuts: [
        {
          id: 0,
          nameDisplay: null,
          command: null,
          imageURL: null,
        },
      ],
    },
    importDialog: false,
    TempModel: [],
    dialog_replace: false,
    replace_modelid: 0,
    replace_modelid_list: { id: 0, name: "x" },
    replace_modelid_lists: [], //{id:0, name: "x"}
    dialog_version: false,
    menus_version: [],
    menus_modeliddisplay_version: 0,
    searchTotalTable_version: 0,
    totalTable_version: 0,
    itemsPerPage_version: 5,
    sortBy: [],
    sortDesc: [],
  }),
  computed: {
    headers() {
      return [
        {
          title: this.$t("no"),
          align: "center",
          sortable: false,
          width: "95px",
        },
        {
          title: this.$t("shortcutMenu"),
          align: "left",
          sortable: true,
          value: "NameDisplay",
        },
        {
          title: this.$t("Comand Name"),
          align: "left",
          sortable: false,
          value: "listCommand",
        },
        { title: this.$t("manage"), align: "center", sortable: false, width: "150px" },
      ];
    },
    areDialogsClosed() {
      return !this.Adddialog && !this.Editdialog;
    },
  },
  watch: {
    options: {
      handler() {
        this.Get();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    filteredModels(index) {
      const selectedModelIds = this.Shortcutmenu.Model.filter(
        (_, idx) => idx !== index
      ).map((model) => model.modelID);

      return this.DDGPTModel.filter(
        (model) => !selectedModelIds.includes(model.modelDisplayID)
      );
    },
    GetDDModelShortcutMenuCommand(id) {
      let self = this;
      self.$call.GetDDModelShortcutMenuCommand(
        id,
        (dataResponse) => {
          if (dataResponse.status === 0) {
            self.Shortcutmenu.listShortcuts = dataResponse.data;
            self.Shortcutmenu.shortcutMenuGroupID = id;
            self.loading = false;
          }
        },
        (errorResource) => {
          self.dialog = false;
          self.isSearch = false;
          self.loading = false;
          console.error(errorResource);
        }
      );
    },
    Search() {
      let self = this;
      self.dialog = true;
      self.isSearch = true;
      self.options.page = 1;
      self.Get();
    },
    Get() {
      let self = this;
      self.loadingTable = true;
      let { page, itemsPerPage, sortBy } = self.options;
      let sortField = null;
      let sortOrder = null;

      if (sortBy && sortBy.length > 0) {
        sortField = sortBy[0].key;
        sortOrder = sortBy[0].order === 'desc';
      }

      let temp = {
        page: self.isSearch ? 1 : page,
        perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
        name: self.searchName,
        sortDesc: sortOrder,
        sortBy: sortField,
      };
      self.$call.GetTableShortcutMenuGroup(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.searchTotalTable = dataResponse.data.total;
            self.menus = dataResponse.data.data;
            self.totalTable = self.isFirst
              ? dataResponse.data.total
              : self.totalTable;
          } else {
            self.menus = [];
            self.searchTotalTable = 0;
            self.totalTable = 0;
          }
          // self.GetDDGPTModel();
          self.loadingTable = false;
          self.isSearch = false;
          self.isFirst = false;
          self.dialog = false;
        },
        (errorResource) => {
          self.loadingTable = false;
          self.isSearch = false;
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    GetDefault() {
      let self = this;
      self.dialog = true;
      self.loading = true;
      const { page, itemsPerPage } = self.options;

      let temp = {
        page: self.isSearch ? 1 : page,
        perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
        name: self.searchName,
        sortDesc: null,
        sortBy: null,
      };
      self.$call.GetTableModelQuickGroup(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.searchTotalTable = dataResponse.data.total;
            self.QuickGroup = dataResponse.data.data;
            self.totalTable = self.isFirst
              ? dataResponse.data.total
              : self.totalTable;
          } else {
            self.menus = [];
            self.searchTotalTable = 0;
            self.totalTable = 0;
          }
        },
        (errorResource) => {
          self.dialog = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    GetQuickGroup() {
      let self = this;
      self.$call.GetModelQuickGroup(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.QuickGroup = dataResponse.data.filter(
              (group) => group.isAllModel != true
            );
          }
        },
        (errorResource) => {
          self.dialog = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    GetDDGPTModel() {
      let self = this;
      self.dialog = true;
      self.$call.DDGPTModelIsPublish(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.DDGPTModel = dataResponse.data;
          } else {
            self.DDGPTModel = [];
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    DeleteGroup(id) {
      let self = this;
      self.deleteItem = id;
      self.dialog_delete = true;
      
    },
    cancelDelete() {
      this.dialog_delete = false;
      this.deleteItem = null;
    },
    confirmDelete() {
      let self = this;
      if (!self.deleteItem) return;
      var id = self.deleteItem
      try {
          self.dialog_delete = false;
          self.dialog = true;

              self.$call.DeleteShortcutMenuGroup(
                id,
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    self.$swal.fire({
                      title: "✔ Successfully Deleted !",
                      showConfirmButton: false,
                      timer: 1500,
                      position: 'top',
                      customClass: {
                        popup: 'success-banner',
                        title: 'success-banner-title'
                      },
                    });
                    self.Editdialog = false;
                    self.Get();
                  }
                  self.dialog = false;
                },
                (errorResource) => {
                  self.dialog = false;
                  self.Adddialog = false;
                  console.error(errorResource);
                }
              );
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },
    Add() {
      let self = this;
      self.Shortcutmenu.shortcutMenuGroupID = null;
      self.Shortcutmenu.groupName = null;
      self.Shortcutmenu.listShortcuts = [
        {
          id: 0,
          nameDisplay: null,
          command: null,
          imageURL: null,
        },
      ];
      // Shortcutmenu: {
      //   shortcutMenuGroupID: null,
      //   groupName: null,
      //   listShortcuts:[
      //     {
      //       id: 0,
      //       nameDisplay: null,
      //       command: null,
      //       imageURL: null,
      //     }
      //   ],
      // },
      self.Adddialog = true;
    },
    Edit(item) {
      let self = this;
      self.Editdialog = true;
      //   Shortcutmenu: {
      //   shortcutMenuGroupID: null,
      //   groupName: null,
      //   listShortcuts:[
      //     {
      //       id: 0,
      //       nameDisplay: null,
      //       command: null,
      //       imageURL: null,
      //     }
      //   ],
      // },
      self.Shortcutmenu.shortcutMenuGroupID = item.shortcutMenuGroupID;
      self.Shortcutmenu.groupName = item.groupName;

      // if (self.Shortcutmenu.isAllModel == false || self.Shortcutmenu.isAllModel == null) {
      //   self.GetModelGroupAndShortcutMenu(self.Shortcutmenu.shortcutMenuGroupID);
      // }
      // else if(self.Shortcutmenu.isAllModel == true ){
      self.GetShortcutMenuByID(item.shortcutMenuGroupID);
      // }
    },
    async GetModelGroupAndShortcutMenu(_modelQuickGroupID) {
      let self = this;
      try {
        self.dialog = true;
        await self.$call.GetModelGroupAndShortcutMenu(
          _modelQuickGroupID,
          async (dataResponse) => {
            if (dataResponse.status == 0) {
              self.Shortcutmenu.Model = dataResponse.data.groupList;
              self.Shortcutmenu.listShortcuts =
                dataResponse.data.quickReplyList;
            }

            if (self.Shortcutmenu.Model.length == 0) {
              self.Shortcutmenu.Model = [
                {
                  modelQuickID: null,
                  name: "",
                  modelID: null,
                  shortcutMenuGroupID: null,
                },
              ];
            }
            if (self.Shortcutmenu.listShortcuts.length == 0) {
              self.Shortcutmenu.listShortcuts = [
                {
                  id: 0,
                  label: null,
                  data: null,
                  type: null,
                  createDate: null,
                  createBy: null,
                  updateDate: null,
                  updateBy: null,
                  shortcutMenuGroupID: null,
                  imageURL: null,
                  activeFlag: true,
                },
              ];
            }
            self.dialog = false;
          },
          () => {
            self.dialog = false;
          }
        );
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },
    async GetShortcutMenuByID(id) {
      let self = this;
      try {
        self.dialog = true;

        //   Shortcutmenu: {
        //   shortcutMenuGroupID: null,
        //   groupName: null,
        //   listShortcuts:[
        //     {
        //       id: 0,
        //       nameDisplay: null,
        //       command: null,
        //       imageURL: null,
        //     }
        //   ],
        // },
        await self.$call.GetShortcutMenuByID(
          id,
          async (dataResponse) => {
            if (dataResponse.status == 0) {
              //self.Shortcutmenu.Model = dataResponse.data.groupList;
              self.Shortcutmenu = dataResponse.data.data;
            }
            // if (self.Shortcutmenu.listShortcuts.length == 0) {
            //   self.Shortcutmenu.listShortcuts = [{
            //     "id": 0,
            //     "label": null,
            //     "data": null,
            //     "type": null,
            //     "createDate": null,
            //     "createBy": null,
            //     "updateDate": null,
            //     "updateBy": null,
            //     "shortcutMenuGroupID": null,
            //     "imageURL": null,
            //     "activeFlag": true
            //   }];
            // }
            self.dialog = false;
          },
          () => {
            self.dialog = false;
          }
        );
      } catch (error) {
        // this.LogTrace(error, 'DeleteGroup');
      }
    },
    async GetDDModelQuick(_modelQuickGroupID) {
      let self = this;
      try {
        self.dialog = true;
        await self.$call.GetDDModelQuick(
          { shortcutMenuGroupID: _modelQuickGroupID },
          async (dataResponse) => {
            if (dataResponse.status == 0) {
              if (
                self.Shortcutmenu.Model.length == 1 &&
                self.Shortcutmenu.Model[0].modelID == null &&
                self.Shortcutmenu.Model[0].shortcutMenuGroupID == null &&
                self.Shortcutmenu.Model[0].name == ""
              ) {
                self.Shortcutmenu.Model = dataResponse.data;
              } else {
                let tempGroup = self.Shortcutmenu.Model;
                self.Shortcutmenu.Model = self.Shortcutmenu.Model.concat(
                  dataResponse.data
                );
                if (self.RedundantCheck(self.Shortcutmenu.Model)) {
                  self.dialog = false;
                  alert("The group must not have any duplicated models.");
                  self.Shortcutmenu.Model = tempGroup;
                  self.importDialog = false;
                  return;
                }
              }
            }

            if (
              self.Shortcutmenu.Model.length == 0 &&
              dataResponse.data.length
            ) {
              self.Shortcutmenu.Model = [
                {
                  modelQuickID: null,
                  name: "",
                  modelID: null,
                  shortcutMenuGroupID: null,
                },
              ];
            }

            self.dialog = false;
          },
          () => {
            self.dialog = false;
          }
        );
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },
    View(item) {
      let self = this;
      const routeData = self.$router.resolve({
        name: "GPTModelDetail",
        query: {
          id: item.id,
        },
      });
      window.open(routeData.href, "_blank");
    },
    Clear() {
      let self = this;
      self.Shortcutmenu.shortcutMenuGroupID = null;
      self.Shortcutmenu.listShortcuts = null;
      self.Shortcutmenu.Name = null;
      self.Shortcutmenu.Model = null;
      self.Shortcutmenu.isAllModel = false;
      self.Editdialog = false;
      self.Adddialog = false;
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      this.today = dd + "/" + mm + "/" + yyyy;
    },
    substring(text) {
      if (text != null) {
        if (text.length > 50) {
          return text.substring(0, 50) + "...";
        }
        return text;
      }
      return text;
    },
    async Save() {
      let self = this;
      try {
        // Shortcutmenu: {
        //   shortcutMenuGroupID: null,
        //   groupName: null,
        //   listShortcuts:[
        //     {
        //       id: 0,
        //       nameDisplay: null,
        //       command: null,
        //       imageURL: null,
        //     }
        //   ],
        // },Shortcutmenu.groupName
        if (
          self.Shortcutmenu.groupName == "" ||
          self.Shortcutmenu.groupName == null
        ) {
          self.$swal.fire({
            icon: "warning",
            title: self.$t("warning"),
            text: self.$t("warningFillAll"),
            showConfirmButton: false,
            timer: 1800,
          });
          return;
        }
        if (
          self.Shortcutmenu.listShortcuts.some(
            (e) =>
              !e.command ||
              e.command.trim() === "" ||
              !e.nameDisplay ||
              e.nameDisplay.trim() === ""
          )
        ) {
          self.$swal.fire({
            icon: "warning",
            title: "Please fill the required fields!!!",
            showConfirmButton: false,
            timer: 2000,
          });
          return;
        }
        // let temp = {
        //   listShortcuts: self.Shortcutmenu.sho
        // }
        self.dialog = true;
        if (self.Adddialog) {
          await self.$call.CreateShortcutMenuGroup(
            self.Shortcutmenu,
            async (dataResponse) => {
              if (dataResponse.status == 0) {
                self.$swal.fire({
                  title: "✔ Shortcut Menu Created" + dataResponse.message,
                  showConfirmButton: false,
                  timer: 1500,
                  backdrop: false,
                  position: 'top',
                  customClass: {
                  popup: 'success-banner',
                  title: 'success-banner-title'
                },
                });
                self.totalTable = self.totalTable + 1;
                self.Get();
                // self.CommandClear();
                self.Adddialog = false;
              } else if (dataResponse.status == 3) {
                self.$swal.fire({
                  icon: "warning",
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 2000,
                });
              }
              self.dialog = false;
            },
            (errorResource) => {
              self.dialog = false;
              // self.Adddialog = false;
              console.error(errorResource);
            }
          );
        } else if (self.Editdialog) {
          await self.$call.UpdateShortcutMenuGroup(
            self.Shortcutmenu,
            async (dataResponse) => {
              if (dataResponse.status == 0) {
                self.$swal.fire({
                  icon: "success",
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 1500,
                });
                self.Get();
                // self.CommandClear();
                self.Editdialog = false;
              } else if (dataResponse.status == 3) {
                self.$swal.fire({
                  icon: "warning",
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 2000,
                });
              }
              self.dialog = false;
            },
            (errorResource) => {
              self.dialog = false;
              // self.Editdialog = false;
              console.error(errorResource);
            }
          );
        }
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },

    Plus_ModelQuick(index) {
      var that = this;
      that.Shortcutmenu.Model.splice(index + 1, 0, {
        modelQuickID: null,
        name: "",
        modelID: null,
        shortcutMenuGroupID: null,
      });
    },
    Minus_ModelQuick(index) {
      var that = this;
      that.Shortcutmenu.Model.splice(index, 1);
    },
    Plus_ShortcutMenu(index) {
      var that = this;

      // Shortcutmenu: {
      //   shortcutMenuGroupID: null,
      //   groupName: null,
      //   listShortcuts:[
      //     {
      //       id: 0,
      //       nameDisplay: null,
      //       command: null,
      //       imageURL: null,
      //     }
      //   ],
      // },
      that.Shortcutmenu.listShortcuts.splice(index + 1, 0, {
        id: 0,
        nameDisplay: null,
        command: null,
        imageURL: null,
      });
    },
    Minus_ShortcutMenu(index) {
      var that = this;
      that.Shortcutmenu.listShortcuts.splice(index, 1);
    },

    Click_FileButtonShortcutMenu(_indexImportFile) {
      document.getElementById("inputfileShortcutMenu").click();
      this.indexImportFile = _indexImportFile;
    },

    ShortcutMenuIcon(e_para) {
      try {
        var that = this;

        // var MAX_WIDTH = 50;
        // var MAX_HEIGHT = 50;

        var MAX_WIDTH = 120;
        var MAX_HEIGHT = 80;

        that.dialog = true;
        const files = e_para.target.files;
        if (
          files[0] == undefined ||
          (files[0] != undefined && files.length > 0 && files[0].size == 0) ||
          that.indexImportFile == null
        ) {
          that.dialog = false;
          that.$swal.fire({
            title: "เกิดข้อผิดพลาด!",
            text: "Something went wrong!",
            icon: "error",
          });

          return;
        }

        if (
          files[0] !== undefined &&
          (files[0].type == "image/jpeg" || files[0].type == "image/png")
        ) {
          // if (files[0] !== undefined && (files[0].type.indexOf("image") != -1)) {
          var fileName_H = files[0].name;

          if (fileName_H.lastIndexOf(".") <= 0) {
            return;
          }
          const fr = new FileReader();
          fr.readAsDataURL(files[0]);
          fr.addEventListener("load", (e) => {
            var img = document.createElement("img");
            // img.style.width = "25px";
            // img.style.height = "25px";
            img.onload = function () {
              var width = img.width;
              var height = img.height;

              // Change the resizing logic
              if (width > height) {
                if (width > MAX_WIDTH) {
                  height = height * (MAX_WIDTH / width);
                  width = MAX_WIDTH;
                }
              } else {
                if (height > MAX_HEIGHT) {
                  width = width * (MAX_HEIGHT / height);
                  height = MAX_HEIGHT;
                }
              }

              // Dynamically create a canvas element
              var canvas = document.createElement("canvas");
              // canvas.style.width = MAX_WIDTH+'px';
              // canvas.style.height = MAX_HEIGHT+ 'px';
              // var canvas = document.getElementById("canvas");
              var ctx = canvas.getContext("2d");
              ctx.canvas.width = width;
              ctx.canvas.height = height;
              // Actual resizing
              ctx.drawImage(img, 0, 0, width, height);
              // Show resized image in preview element
              var dataurl = canvas.toDataURL(files[0].type);
              that.Shortcutmenu.listShortcuts[that.indexImportFile].imageURL =
                dataurl;
              that.Shortcutmenu.listShortcuts[that.indexImportFile].imgName =
                files[0].name;
              document.getElementById("inputfileShortcutMenu").value = "";
              that.dialog = false;
            };
            img.src = e.target.result;
          });
        } else {
          that.indexImportFile = null;

          document.getElementById("inputfileShortcutMenu").value = "";

          that.dialog = false;

          that.$swal.fire({
            title: "เกิดข้อผิดพลาด!",
            text: "ลองรับไฟล์ jpeg หรือ png เท่านั้น",
            icon: "error",
          });
        }
      } catch {
        that.indexImportFile = null;

        document.getElementById("inputfileShortcutMenu").value = "";

        that.dialog = false;
        that.$swal.fire({
          title: "เกิดข้อผิดพลาด!",
          text: "Something went wrong!",
          icon: "error",
        });
      }
    },
  },
  mounted() {
    this.GetDate();
    // this.GetQuickGroup();
  },
};
</script>
<style scoped>
/* #Editdialog_ID::-webkit-scrollbar {
  height: 10px;
} 

#Editdialog_ID::-webkit-scrollbar {
  width: 10px;
}

#Editdialog_ID::-webkit-scrollbar-track {
  background-color: gainsboro;
  border-radius: 5px;
}


#Editdialog_ID::-webkit-scrollbar-thumb { 

  background-color: rgb(0, 78, 140); 

  border-radius: 5px;

}
*/

#tableListPop_Id {
  border-collapse: collapse;
}

#tableListPop_Id td,
th {
  /* border: 1px solid #dddddd; */
  border-bottom: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

#tableListPop_Id tr:nth-child(even) {
  /* background-color: #dddddd; */
}

#tableListPop_Id tbody {
  /* display:block; */
  height: 100%;
  overflow: auto;
}

#tableListPop_Id thead,
#tableListPop_Id tbody tr {
  /* display:table; */
  /* width:100%; */
  /* table-layout:fixed; */
}

.card2 {
  border-radius: 10px !important;
  margin-bottom: 2rem;
  padding-top: 1rem;
}

.card {
  border-radius: 10px !important;
  margin-bottom: 2rem;
  height: 90vh;
  overflow: auto;
  margin: 0;
  padding: 0;
}

textarea {
  min-height: 800px !important;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}
:deep(.v-data-table tbody tr) {
  transition: all 0.2s ease;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

:deep(.v-data-table tbody tr:hover) {
  background: rgba(0, 0, 0, 0.02);
  /* transform: translateY(-1px); */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

:deep(.v-data-table-header) {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 2px solid #dee2e6;
}

:deep(.v-data-table-header th) {
  color: #495057 !important;
  font-weight: 700 !important;
  font-size: 0.875rem !important;
  padding: 1rem !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid rgba(25, 118, 210, 0.1) !important;
}

/* Modern Dialog Styles */
.modern-dialog {
  border-radius: 20px !important;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15) !important;
}

/* Dialog Header */
/* .dialog-header {
  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
  color: white;
  padding: 24px !important;
  border-bottom: none;
}

.edit-header {
  background: linear-gradient(135deg, #f57c00 0%, #ef6c00 100%);
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
}

.header-left {
  display: flex;
  align-items: flex-start;
  gap: 16px;
}

.header-icon {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.dialog-title {
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0;
  color: white;
  letter-spacing: 0.025em;
}

.dialog-subtitle {
  font-size: 0.9rem;
  margin: 0;
  color: rgba(255, 255, 255, 0.8);
  font-weight: 400;
}

.header-right {
  display: flex;
  align-items: center;
}

.close-btn {
  background: rgba(255, 255, 255, 0.1) !important;
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
}

.close-btn:hover {
  background: rgba(255, 255, 255, 0.2) !important;
  transform: scale(1.05);
} */

/* Dialog Content */
.dialog-content {
  padding: 32px !important;
  max-height: 70vh;
  overflow-y: auto;
}

.form-container {
  background: white;
  border-radius: 16px;
  padding: 20px;
  border: 1px solid #C9C9C9;
}

.form-section {
  margin-bottom: 32px;
}

.form-section:last-child {
  margin-bottom: 0;
}

.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 12px;
  gap: 8px;
  /* border-bottom: 2px solid rgba(25, 118, 210, 0.1); */
}
.section-header :deep(.v-img) {
  flex-shrink: 0; /* Prevent image from shrinking */
  margin: 0 !important; /* Remove any default margins */
}
.section-title {
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0;
  color: #171717;
  letter-spacing: 0.025em;
  line-height: 1;
  gap: 8px;
}

.count-chip {
  background: rgba(33, 150, 243, 0.1) !important;
  color: #1565c0 !important;
  font-weight: 600;
}

/* Input Styling */
.input-wrapper {
  margin-bottom: 20px;
}

.input-label {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  font-weight: 600;
  color: #424242;
  font-size: 0.9rem;
  gap: 4px;
}

.required-asterisk {
  color: #d32f2f;
  font-weight: 700;
}

.help-icon {
  cursor: help;
  transition: all 0.2s ease;
  opacity: 0.7;
}

.help-icon:hover {
  opacity: 1;
  color: #1976d2 !important;
  transform: scale(1.1);
}

.modern-input :deep(.v-field) {
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;
}

.modern-input :deep(.v-field:hover) {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.modern-input :deep(.v-field--focused) {
  box-shadow: 0 4px 16px rgba(25, 118, 210, 0.2);
}

/* Table Styling */
.table-container {
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.08);
  margin-bottom: 16px;
}

.modern-table {
  background: white;
}

.table-header {
  background: #FFF2F2;
  color: #171717 !important;
  font-weight: 700 !important;
  font-size: 0.875rem !important;
  text-transform: none;
  letter-spacing: 0.5px;
  padding: 16px 12px !important;
  border-bottom: 2px solid rgba(25, 118, 210, 0.1) !important;
}

.table-header.actions-col {
  width: 120px !important;
  min-width: 120px !important;
  max-width: 120px !important;
}
.table-header.number-col {
  width: 60px !important;
  min-width: 60px !important;
  max-width: 60px !important;
}

.table-header.label-col {
  width: 200px !important;
  min-width: 200px !important;
}
.table-row {
  transition: all 0.2s ease;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.table-row:hover {
  background: rgba(25, 118, 210, 0.02);
}

.table-cell {
  padding: 12px !important;
  vertical-align: middle;
}

.number-cell {
  text-align: center;
  font-weight: 600;
  color: #666;
}

.upload-cell,
.preview-cell {
  text-align: center;
}

.actions-cell {
  text-align: center;
}

/* Table Components */
.table-input :deep(.v-field) {
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.table-input :deep(.v-field:hover) {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.upload-btn {
  border-radius: 8px !important;
  font-weight: 500;
  text-transform: none;
  white-space: nowrap;
  min-width: auto;
}

.image-preview {
  display: flex;
  justify-content: center;
  align-items: center;
}

.preview-avatar {
  border: 2px solid #C9C9C9;
  transition: all 0.3s ease;
  padding: 10px;
  border-radius: 12px;
  width: 50px;
  height: 50px;
  margin: auto;
}

.preview-avatar.has-image {
  border-color: #1976d2;
  box-shadow: 0 2px 8px rgba(25, 118, 210, 0.2);
}

.preview-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.action-buttons {
  display: flex;
  gap: 4px;
  justify-content: center;
  align-items: center;
}

/* .dialog-action-btn {
  transition: all 0.2s ease;
}

.dialog-action-btn:hover {
  transform: scale(1.1);
} */

/* Info Messages */
.info-message {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  background: rgba(33, 150, 243, 0.08);
  border-radius: 8px;
  border-left: 4px solid #2196f3;
  font-size: 0.875rem;
  color: #1565c0;
  margin-top: 16px;
}

/* Dialog Actions */
/* .dialog-actions {
  padding: 24px 32px !important;
  background: white;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
}

.actions-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.actions-left {
  display: flex;
  align-items: center;
}

.actions-right {
  display: flex;
  gap: 12px;
}

.dialog-action-btn {
  height: 44px;
  border-radius: 12px !important;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.025em;
  transition: all 0.3s ease;
  min-width: 120px;
}

.cancel-btn {
  color: #757575 !important;
  border-color: #e0e0e0 !important;
}

.cancel-btn:hover {
  background: rgba(117, 117, 117, 0.04) !important;
  border-color: #bdbdbd !important;
  transform: translateY(-1px);
}

.save-btn {
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.3) !important;
}

.save-btn:hover {
  box-shadow: 0 6px 16px rgba(25, 118, 210, 0.4) !important;
  transform: translateY(-1px);
}

.summary-chip {
  background: rgba(76, 175, 80, 0.1) !important;
  color: #2e7d32 !important;
  font-weight: 600;
} */

/* Scrollbar Styling */
.dialog-content::-webkit-scrollbar {
  width: 6px;
}

.dialog-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.dialog-content::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.dialog-content::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Responsive */
@media (max-width: 900px) {
  .dialog-header {
    padding: 20px 24px !important;
  }
  
  .dialog-content {
    padding: 24px !important;
  }
  
  .form-container {
    padding: 20px;
  }
  
  .table-container {
    overflow-x: auto;
  }
  
  .modern-table {
    min-width: 800px;
  }
  
  /* .dialog-actions {
    padding: 20px 24px !important;
    flex-direction: column-reverse;
    gap: 16px;
  } */
  
  /* .actions-content {
    flex-direction: column-reverse;
    gap: 16px;
    width: 100%;
  } */
  
  /* .actions-right {
    width: 100%;
    flex-direction: column;
  } */
  
  /* .dialog-action-btn {
    width: 100%;
  } */
}

/* Animations */
@media (prefers-reduced-motion: no-preference) {
  .modern-dialog {
    animation: dialogSlideIn 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  }
  
  @keyframes dialogSlideIn {
    from {
      opacity: 0;
      transform: translateY(-30px) scale(0.95);
    }
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }
}

/* Add Model Section */
.add-model-section {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
  transition: all 0.3s ease;
}

.add-model-btn {
  border-radius: 12px !important;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.025em;
  transition: all 0.3s ease;
  min-width: 160px;
  height: 44px;
  border: 2px solid #4caf50 !important;
}

.add-model-btn:hover {
  background: #4caf50 !important;
  color: white !important;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(76, 175, 80, 0.3) !important;
}
:deep(thead) {
  background-color: #FFE4E1 !important;
}
.v-table--has-top :deep(.v-table__wrapper) {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-center .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 15px;
}
:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-left .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 15px;
}
:deep(.v-pagination__first),
:deep(.v-pagination__last) {
  display: none !important;
}
:deep(.v-data-table-footer .v-field) {
  border-radius: 10px !important;
  width: 70px !important;
}
.title-with-chip {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}
.summary-chip {
  border-radius: 40px;
  background: rgba(56, 89, 208, 0.10)!important;  
  color: #3859D0 !important;
  font-weight: 600;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
}
.actionbtns{
  background: transparent!important;

}
.addbtn{
  color: #2ABF56!important;
}
.removebtns{
  color: #C30000!important;
  background: white!important;
}
</style>
